import React from 'react';
import Modal from '../../../../shared/modal';


interface IDiscrepancyModal {
    openModal: boolean;
    data: any;
    handleCloseModal: () => void;
}

const DiscrepancyModal = ({
    openModal,
    data,
    handleCloseModal,
}: IDiscrepancyModal) => {

    const onCloseModal = () => {
        handleCloseModal();
    }

    return (
        <Modal
            open={openModal}
            showInRight
            onClose={() => onCloseModal()}
            title='Purchase Details'
            contentContainerStyle='!min-w-[100vw] md:!min-w-[650px]'>
            <div className={'p-2 !min-w-[90vw] md:!min-w-[600px]'}>
                <div className='border-b-2 border-slate-200 pb-2 my-1'>
                    <p className='font-medium text-slate-700'>Details</p>
                </div>
                <div className='bg-[#e4ede657] rounded-[6px] p-3 mb-4'>
                    <p className='font-bold mb-1'>Bank</p>
                    <div className='mb-4'>
                        <p>{data?.bankTransactions?.transactionsMatched}</p>
                    </div>
                    <div className='mb-4'>
                        <p>{data?.bankTransactions?.unmatchedTransactions}</p>
                    </div>
                </div>
                <div className='bg-[#e4ede657] rounded-[6px] p-3 mb-4'>
                    <p className='font-bold mb-1'>Opera</p>
                    <div className='mb-4'>
                        <p>{data?.operaTransactions?.transactionsMatched}</p>
                    </div>
                    <div className='mb-4'>
                        <p>{data?.operaTransactions?.unmatchedTransactions}</p>
                    </div>
                </div>
            </div>
        </Modal >
    )
}
export default DiscrepancyModal;